import { createRoute, redirect } from '@tanstack/react-router';
import { Route as appRoute } from '../../../app.js';
import { useAuthStore } from '../../../../lib/auth.js';
import { AdminPageHeader } from '../../../../components/admin/AdminPageHeader.js';
import { AdminUsersPanel } from '../../../../components/admin/AdminUsersPanel.js';

export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: 'admin/users',
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role;
    if (role !== 'super_admin') throw redirect({ to: '/app' });
  },
  component: AdminUsersPage,
});

function AdminUsersPage() {
  return (
    <div>
      <AdminPageHeader
        title="Users"
        description="Look up a user by email to manage their account security — e.g. reset their two-factor authentication if they're locked out."
      />
      <AdminUsersPanel />
    </div>
  );
}
